<template>
  <div>
    <v-snackbar class="snakbar-sty rounded-pill" transition="slide-x-reverse-transition" v-model="snackbar" :timeout="3000" :value="true" :color="snackbarclr" absolute outlined>
      <v-icon class="mr-2" :color="snackbarclr">mdi-alert-outline</v-icon>
      {{ snackmsgbar }}
      <v-icon @click="snackbar = false" class="float-right" :color="snackbarclr">mdi-close-circle</v-icon>
    </v-snackbar>
    <div class="body-row pb-3 px-4 px-md-6 px-lg-8 pt-lg-6">
      <zebu-logo />
      <v-card class="elevation-0">
        <p class="mynt-eyebrow font-weight-bold mb-2">Welcome to Zebu</p>
        <p class="mynt-title font-weight-bold mb-7">Get OTP</p>

        <div>
          <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="validate()">
            <v-text-field :disabled="valdatadis" v-model="otpuserId" :rules="otpuseridRules" color="#0037B7" class="mynt-field mb-3" label="Client ID" required oninput="this.value = this.value.toUpperCase()"></v-text-field>

            <v-text-field
              :disabled="valdatadis"
              v-model="otppan"
              :append-icon="otppaneye ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="otppanRules"
              :type="otppaneye ? 'text' : 'password'"
              color="#0037B7"
              class="mynt-field mb-3"
              label="PAN"
              @click:append="otppaneye = !otppaneye"
              required
              oninput="this.value = this.value.toUpperCase()"
            ></v-text-field>

            <div class="mt-4" :style="`cursor: ${valid != true ? 'not-allowed' : 'auto'};`">
              <v-btn height="47px" :disabled="!valid" type="submit" color="#0037B7" class="text-none mynt-btn elevation-0 mb-1" block> <span class="white--text mynt-btn-label">Send OTP</span></v-btn>
            </div>

            <p class="mb-0 mt-3">
              <v-row no-gutters>
                <v-col cols="5" class="text-left pr-3">
                  <v-btn text :ripple="false" color="#0037B7" class="px-0 mb-2 elevation-0" small @click="goback()">
                    <span class="mynt-link text-none"> Back to login </span>
                  </v-btn>
                </v-col>
                <v-col cols="7" class="text-right">
                  <v-list-item-title>
                    <v-btn text :ripple="false" color="#0037B7" class="px-0 mb-2 elevation-0" small @click="forgotPws()">
                      <span class="mynt-link text-none"> Forgot password</span>
                    </v-btn></v-list-item-title
                  >
                </v-col>
              </v-row>
            </p>
          </v-form>
          <p class="mynt-signup mb-0 text-center mt-6">Don't have an account yet? <a class="mynt-link" style="text-decoration: none" href="https://oa.mynt.in?ref=desk">Sign Up</a></p>
        </div>
      </v-card>
      <v-footer padless absolute color="#fff">
        <v-col class="text-center font-weight-medium fs-13 px-lg-8 px-md-6 px-lg-8 pb-2 mynt-legal" cols="12"
          ><span class="font-weight-bold fs-14 black--text"> Zebu Share and Wealth Managements Pvt. Ltd. </span><br />
          SEBI Registration No: INZ000174634 | NSE : 13179 | BSE : 6550 | MCX : 55730 | CDSL : 12080400 | AMFI ARN : 113118 | Research Analyst : INH200006044
        </v-col>
      </v-footer>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {mynturl} from "../../apiUrl.js";
import ZebuLogo from "../../components/ZebuLogo.vue";

export default {
  components: {ZebuLogo},

  data: () => ({
    snackbar: false,
    snackbarclr: "default",
    snackmsgbar: "",
    valdatadis: false,
    valid: true,
    otpuserId: "",
    otpuseridRules: [(v) => !!v || "Client Id is required"],
    otppaneye: false,
    otppan: "",
    otppanRules: [(v) => !!v || "PAN is required", (v) => /[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(v) || "PAN number must be valid"],
  }),

  async created() {},

  mounted() {
    this.actid = localStorage.getItem("actid");
    if (this.actid != null) {
      this.otpuserId = this.actid;
    } else {
      this.otpuserId = "";
    }
  },

  methods: {
    validate() {
      this.$refs.form.validate();
      if (this.$refs.form.validate() != false) {
        var axiosThis = this;
        var data = `jData={"uid":"${this.otpuserId}","pan":"${this.otppan}"}`;
        var config = {
          method: "post",
          url: `${mynturl}/FgtPwdOTP`,
          headers: {
            "Content-Type": "text/plain",
            Cookie: "NWC_ID=3e03100f85c0155ffb62d5d9bcc0ee273e804c489e430ddb9e00eda1aab50f54",
          },
          data: data,
        };
        axios(config)
          .then(function (response) {
            // console.log(JSON.stringify(response.data));
            // console.log("validate", response.data);
            if (response.data.ReqStatus == "OTP generation success") {
              axiosThis.valdatadis = true;
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "#22ab94";
              axiosThis.snackmsgbar = "OTP generation success, send through email/SMS.";
              axiosThis.otpuserId = response.data.uid;
              setTimeout(function () {
                axiosThis.$router.push("/sso");
              }, 2000);
            } else if (response.data.emsg == "Error Occurred : Wrong user id or user details" || response.data.ReqStatus == "Invalid User") {
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "#f23645";
              axiosThis.snackmsgbar = "Invalid User or Invalid Client ID.";
            } else if (response.data.ReqStatus == "Invalid PAN") {
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "#f23645";
              axiosThis.snackmsgbar = "Wrong PAN number.";
            } else {
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "#f23645";
              if (response.data.emsg || response.data.ReqStatus) {
                axiosThis.snackmsgbar = response.data.emsg;
              } else {
                axiosThis.snackmsgbar = "something went wrong, Kindly try again.";
              }
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    goback() {
      this.$router.push("/sso");
    },
    forgotPws() {
      this.$router.push("/forgot_password");
    },
  },
};
</script>
